import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetTopCompetitionsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	timezoneOffset: Types.Scalars['Int'];
	language: Types.Scalars['Language'];
	groupBy: Types.SportEventAggregation;
	filter?: Types.Maybe<Types.SportEventFilter>;
	first: Types.Scalars['Int'];
}>;

export type GetTopCompetitionsQuery = { __typename?: 'Query' } & {
	sportEventBucketsV2: { __typename?: 'SportEventBucketsConnectionV2' } & {
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'SportEventBucketsEdgeV2' } & {
					key: { __typename?: 'SportEventAggregationKeyV2' } & {
						competition?: Types.Maybe<
							{ __typename?: 'SportCompetitionV2' } & {
								content: { __typename?: 'SportCompetitionContentV2' } & Pick<
									Types.SportCompetitionContentV2,
									'name' | 'fullPath'
								>;
							}
						>;
					};
				}
			>
		>;
	};
};

export const GetTopCompetitionsDocument = gql`
	query GetTopCompetitions(
		$country: Country!
		$timezoneOffset: Int!
		$language: Language!
		$groupBy: SportEventAggregation!
		$filter: SportEventFilter
		$first: Int!
	) {
		sportEventBucketsV2(
			country: $country
			timezoneOffset: $timezoneOffset
			groupBy: $groupBy
			filter: $filter
			first: $first
		) {
			edges {
				key {
					competition {
						content(country: $country, language: $language) {
							name
							fullPath
						}
					}
				}
			}
		}
	}
`;
